"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFeatherIcon = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const computeStyledMargins_1 = require("../../general/utility/computeStyledMargins");
// Q: why are we using "!important" here?
// Q2: color seems mandatory, but was not provided in all instances
exports.StyledFeatherIcon = styled_components_1.default.i `
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '18px')} !important;
  font-weight: ${({ bold }) => bold && 'bold'};
  color: ${({ color }) => color};

  ${computeStyledMargins_1.computeStyledMargins}
`;
